module.exports = "/images/readmore.png";